import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from './Components/Home/Home';
import Band from './Components/Band/Band';
import Orchestra from './Components/Orchestra/Orchestra';
import Mariachi from './Components/Mariachi/Mariachi';
import Choir from './Components/Choir/Choir';
import Calendar from './Components/Calendar/Calendar';
import Contact from './Components/Contacts/Contacts';
import Links from './Components/Links/Links';
import Form from './Components/Form/Form';
import Login from './Components/Login/Login';
import AreaJ from './Components/AreaB/AreaJ';
import AreaB from './Components/AreaB';
import Fourohfour from './Components/Fourohfour/Fourohfour';

export default (
  <Switch>
    <Route path="/Band" component={Band} />
    <Route path="/Mariachi" component={Mariachi} />
    <Route path="/Orchestra" component={Orchestra} />
    <Route path="/Choir" component={Choir} />
    <Route path="/Calendar" component={Calendar} />
    <Route path="/Contacts" component={Contact} />
    <Route path="/Links" component={Links} />
    <Route path="/Form" component={Form} />
    <Route path="/admin" component={Login} />
    <Route exact path="/area-j" component={AreaJ} />
    <Route exact path="/area-b" component={AreaB} />
    <Route exact path="/" component={Home} />
    <Route path="*" component={Fourohfour} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/routes.js